import '@cinch-labs/design-system/dist/index.css'
import '@cinch-labs/cds-tokens/dist/css/cds-tokens.css'

import { registerRumContext } from '@cinch-labs/shared-util'
import { useUserStore } from '@cinch-nx/data-user'
import { AnalyticsWithZendesk } from '@cinch-nx/shared-analytics'
import { preserveReferrerAndCID } from '@retail-common/util-analytics'
import { CookieConsentWrapper } from '@cinch-nx/shared-ui'
import {
  AppPropsWithLayoutPropsWithError,
  Layout,
} from '@in-life-and-loyalty/vaps-ui'
import dynamic from 'next/dynamic'
import { useEffect } from 'react'
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'

import '../stores'
import './_app.css'

const ClientSideHead = dynamic(() => import('../components/client-side-head'), {
  ssr: false,
})

function CustomApp({
  Component,
  pageProps,
  err,
}: AppPropsWithLayoutPropsWithError) {
  const { layoutProps, ...componentProps } = pageProps

  const { fetchUser } = useUserStore()

  const BUILD_ID = process.env.NEXT_PUBLIC_BUILD_ID
  registerRumContext(BUILD_ID)

  useEffect(() => {
    preserveReferrerAndCID()
    fetchUser()
  }, [])

  return (
    <>
      <ClientSideHead />
      <AnalyticsWithZendesk />
      <Layout {...layoutProps} useVerticalGradient>
        <>
          <Component {...componentProps} err={err} />
          <CookieConsentWrapper />
        </>
      </Layout>
    </>
  )
}

export default CustomApp
